// https://stackoverflow.com/questions/63961803/eslint-says-all-enums-in-typescript-app-are-already-declared-in-the-upper-scope
/* eslint-disable no-shadow */
export const SERVICE_PAGE_NAME = 'service-page';
export const SERVICE_PAGE_SLOT_ID = 'slot1';
export const SERVICE_LIST_PAGE_NAME = 'book-online';
export const SUBSCRIPTION_PRICING_EXPERIMENT =
  'specs.bookings.SubscriptionPricingUoU';
export const SESSIONS_PAGINATION_EXPERIMENT =
  'specs.bookings.SessionsPaginationServiceDetails';
export const SHOW_REMAINING_COURSE_SESSIONS_EXPERIMENT =
  'specs.bookings.ShowRemainingCourseSessions';
export const SERVICE_DETAILS_WDS_MIGRATION = 'serviceDetailsWdsMigration';

export enum FailReasons {
  Premium = 'premium',
  PricingPlanNotInstalled = 'pricing_plan_not_installed',
  NoPlansAssignedToService = 'no_plans_assigned_to_service',
}
